import { render, staticRenderFns } from "./NoticeboardCard.vue?vue&type=template&id=0de06035&"
import script from "./NoticeboardCard.vue?vue&type=script&lang=js&"
export * from "./NoticeboardCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports